export default "__VITE_ASSET__1t$pnaIO__"